import {
    Box,
    Button,
    Modal,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
} from '@mui/material';
import {CartItem} from '../../../api/models';
import { convertPaiseToRupees } from '../../../common/utils';

interface ItemDetailsModalProps {
    open: boolean;
    cartItems: CartItem[];
    onClose: () => void;
}

export const ItemDetailsModal: React.FC<ItemDetailsModalProps> = ({open, cartItems, onClose}) => {
    return (
        <Modal open={open} onClose={onClose}>
            <Box
                sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: 800,
                    bgcolor: 'background.paper',
                    borderRadius: 2,
                    boxShadow: 24,
                    p: 4,
                }}>
                <Typography variant='h6' gutterBottom>
                    Order Items
                </Typography>

                {cartItems.length > 0 ? (
                    <TableContainer component={Paper}>
                        <Table sx={{minWidth: 650}} aria-label='cart items table'>
                            <TableHead>
                                <TableRow>
                                    <TableCell>
                                        <strong>ID</strong>
                                    </TableCell>
                                    <TableCell>
                                        <strong>Title</strong>
                                    </TableCell>
                                    <TableCell>
                                        <strong>Quantity</strong>
                                    </TableCell>
                                    <TableCell>
                                        <strong>Amount</strong>
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {cartItems.map((item) => (
                                    <TableRow key={item.id}>
                                        <TableCell component='th' scope='row'>
                                            {item.id}
                                        </TableCell>
                                        <TableCell>{item.title}</TableCell>
                                        <TableCell>{item.quantity}</TableCell>
                                        <TableCell>{convertPaiseToRupees(item.priceInPaise)}</TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                ) : (
                    <Typography variant='body2' sx={{mt: 2}}>
                        No items found in this order.
                    </Typography>
                )}

                <Button onClick={onClose} sx={{mt: 2}}>
                    Close
                </Button>
            </Box>
        </Modal>
    );
};
